// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StripePaymentForm {
  max-width: 90vh;
  margin: 0 auto;
}
.StripePaymentForm ::ng-deep .mat-mdc-raised-button.mat-primary {
  --mat-button-protected-container-color: #01579b;
}
.StripePaymentForm__Field {
  margin: 1rem 0;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  padding: 0.25rem;
  background-color: white;
}
.StripePaymentForm__Button {
  margin: 0 0.25rem;
  color: white;
}
.StripePaymentForm__Note {
  font-size: 0.75rem;
  color: #6c757d;
}
.StripePaymentForm__Loader {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(238, 238, 238, 0.75);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.StripePaymentForm__Loader ::ng-deep img {
  position: relative;
  opacity: 0.5;
}
@media screen and (max-width: 768px) {
  .StripePaymentForm__Title {
    font-size: 1rem;
  }
  .StripePaymentForm__CurrentSubscription {
    font-size: 0.75rem;
  }
  .StripePaymentForm__Button {
    margin-top: 1rem;
    font-size: 0.65rem;
    background-color: #01579b;
  }
}

.break {
  content: "";
  display: block;
  flex-basis: 100%;
  height: 10px;
}`, "",{"version":3,"sources":["webpack://./libs/data/services/stripe-payment/src/lib/stripe-payment-form/stripe-payment-form.component.scss"],"names":[],"mappings":"AAEA;EAOE,eAAA;EACA,cAAA;AAPF;AAEI;EACE,+CAAA;AAAN;AAME;EACE,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;AAOE;EACE,iBAAA;EACA,YAAA;AALJ;AAQE;EACE,kBAAA;EACA,cAAA;AANJ;AASE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,qCAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;AAUM;EACE,kBAAA;EACA,YAAA;AARR;AAaE;EACE;IACE,eAAA;EAXJ;EAcE;IACE,kBAAA;EAZJ;EAeE;IACE,gBAAA;IACA,kBAAA;IACA,yBAAA;EAbJ;AACF;;AAiBA;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAdF","sourcesContent":["// Ionic styles will be used instead of Bootstrap\n\n.StripePaymentForm {\n  // TODO: Find out how to share styles properly\n  ::ng-deep {\n    .mat-mdc-raised-button.mat-primary {\n      --mat-button-protected-container-color: #01579b;\n    }\n  }\n  max-width: 90vh;\n  margin: 0 auto;\n\n  &__Field {\n    margin: 1rem 0;\n    border: 1px solid #ccc;\n    border-radius: 0.25rem;\n    padding: 0.25rem;\n    background-color: white;\n  }\n\n  &__Button {\n    margin: 0 0.25rem;\n    color: white;\n  }\n\n  &__Note {\n    font-size: 0.75rem;\n    color: #6c757d;\n  }\n\n  &__Loader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(238, 238, 238, 0.75);\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    ::ng-deep {\n      img {\n        position: relative;\n        opacity: 0.5;\n      }\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    &__Title {\n      font-size: 1rem;\n    }\n\n    &__CurrentSubscription {\n      font-size: 0.75rem;\n    }\n\n    &__Button {\n      margin-top: 1rem;\n      font-size: 0.65rem;\n      background-color: #01579b;\n    }\n  }\n}\n\n.break {\n  content: '';\n  display: block;\n  flex-basis: 100%;\n  height: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
